var _rect, _text, _rect2, _rect3, _circle, _path, _text2, _text3, _circle2, _circle3, _circle4, _rect4, _text4, _text5, _rect5, _text6, _text7, _rect6, _circle5, _path2, _text8, _text9, _rect7, _text0, _path3, _rect8, _text1, _text10, _circle6, _text11, _text12, _path4, _circle7, _text13, _text14, _path5, _circle8, _text15, _text16, _path6, _circle9, _text17, _text18, _path7, _circle0, _text19, _text20, _path8, _rect9, _circle1, _text21, _rect0, _text22, _text23, _rect1, _text24, _text25, _rect10, _text26, _text27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreAfricanFieldInterfaceControllerBridgeDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1400,
    height: 700,
    viewBox: "0 0 1400 700",
    role: "img",
    "aria-label": "FleetCore African field interface desktop bridge",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 700,
    rx: 42,
    fill: "#07152A",
    stroke: "#29405D"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 58,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "THE DRIVER CHATS \xB7 FLEETCORE BUILDS THE RECORD")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 92,
    width: 540,
    height: 500,
    rx: 28,
    fill: "#E8F0EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 92,
    width: 540,
    height: 82,
    rx: 20,
    fill: "#075E54"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 133,
    r: 25,
    fill: "#128C7E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.25 122.25c-1.5 6 4.5 13.5 10.5 15l3.75-3.75-4.5-3-2.25 2.25c-3-1.5-5.25-3.75-6-6l2.25-2.25-3-4.5z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.6500000000000001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 131,
    y: 127,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 17,
    fontWeight: 850
  }, "West Shaft Fleet")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 131,
    y: 148,
    fill: "#CFF6E1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "FleetCore Controller \xB7 18 participants")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 556,
    cy: 123,
    r: 3,
    fill: "#FFFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 556,
    cy: 133,
    r: 3,
    fill: "#FFFFFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 556,
    cy: 143,
    r: 3,
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 197,
    width: 372,
    height: 87,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#C7D5CD"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 93,
    y: 224,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 0
  }, "Thabo, you are at the fuel point."), /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 22
  }, "Are you refuelling FC-217?"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 431,
    y: 273,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "14:18")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 302,
    width: 190,
    height: 56,
    rx: 16,
    fill: "#D8FDD2",
    stroke: "#C7D5CD"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 391,
    y: 329,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 391,
    dy: 0
  }, "Yes"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 547,
    y: 347,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "14:18 \u2713\u2713")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 378,
    width: 446,
    height: 154,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#C7D5CD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 432,
    r: 29,
    fill: "#FFF3DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.64 442.08v-20.16h12.959999999999999v20.16M112.48 442.08h18M117.52 426.24h7.199999999999999v5.04h-7.199999999999999zM127.6 425.52l5.76 5.04v10.08c0 3.5999999999999996 5.04 3.5999999999999996 5.04 0v-9.36",
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 1.584,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 411,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 850
  }, "One step at a time")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 439,
    fill: "#385045",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Photograph the pump before fuelling.")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 462,
    width: 175,
    height: 39,
    rx: 12,
    fill: "#087CFF"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 194,
    y: 487,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "Open camera")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M625 334h80m-12-12 12 12-12 12",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 92,
    width: 610,
    height: 500,
    rx: 28,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 138,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "STRUCTURED FLEETCORE EVENT")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 180,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Refuel record \xB7 FC-217")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 230,
    r: 5,
    fill: "#087CFF"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 810,
    y: 235,
    fill: "#96ACC5",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Driver")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1308,
    y: 235,
    textAnchor: "end",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "Thabo Mokoena")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M780 255H1310",
    stroke: "#29405D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 287,
    r: 5,
    fill: "#30D6A1"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 810,
    y: 292,
    fill: "#96ACC5",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Vehicle")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1308,
    y: 292,
    textAnchor: "end",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "FC-217 \xB7 GP 42 XX GP")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M780 312H1310",
    stroke: "#29405D"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 344,
    r: 5,
    fill: "#F5AE35"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 810,
    y: 349,
    fill: "#96ACC5",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Opening mileage")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 1308,
    y: 349,
    textAnchor: "end",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "184,263 km")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M780 369H1310",
    stroke: "#29405D"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 401,
    r: 5,
    fill: "#F54291"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 810,
    y: 406,
    fill: "#96ACC5",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Pump evidence")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 1308,
    y: 406,
    textAnchor: "end",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "Photo captured \xB7 67.4 L")), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M780 426H1310",
    stroke: "#29405D"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 458,
    r: 5,
    fill: "#4BB5FF"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 810,
    y: 463,
    fill: "#96ACC5",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Location")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 1308,
    y: 463,
    textAnchor: "end",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "West Shaft fuel point")), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M780 483H1310",
    stroke: "#29405D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 522,
    width: 530,
    height: 44,
    rx: 14,
    fill: "#10243E"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 806,
    cy: 544,
    r: 6,
    fill: "#30D6A1"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 550,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "The conversation becomes auditable evidence.")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 618,
    width: 390,
    height: 52,
    rx: 16,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 639,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "PLAIN LANGUAGE")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 658,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "One clear request at a time")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 618,
    width: 390,
    height: 52,
    rx: 16,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 498,
    y: 639,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "PHOTO-LED")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 498,
    y: 658,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "Show the event, then confirm")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 910,
    y: 618,
    width: 390,
    height: 52,
    rx: 16,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 928,
    y: 639,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "FAMILIAR INTERACTION")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 928,
    y: 658,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "Controller-like guidance")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreAfricanFieldInterfaceControllerBridgeDesktop);
export default __webpack_public_path__ + "static/media/fleetcore-african-field-interface-controller-bridge-desktop.aff23ca6afbbe8d6371b169bd81a8153.svg";
export { ForwardRef as ReactComponent };